function initDynamicForm(sectionSettings, leadForm, sectionId, locationArr) {
	var mndFileds = new Array("First Name", "Last Name", "email", "phone", "Lead_Type", "Lead_Comments");
	var fldLangVal = new Array("First Name", "Last Name", "Email", "Phone", "Interested In", "Comments");
	const submitBtn = leadForm.querySelector("#formsubmit");
	const formSection = document.getElementById(`shopify-section-${sectionId}`);

	let stripe;
	if (sectionSettings.form_render_mode == "STEP_FORM_INJECT" || sectionSettings.form_render_mode == "STEP_FORM") {
		stripe = Stripe(sectionSettings.stripe_api_key);
	}

	let gRecaptchaWidget = null;
	let isExternalEndpoint = false;
	let storeLocations = locationArr;
	leadForm.addEventListener("submit", async (e) => {
		e.preventDefault();
		setLoading(true);
		// await testingSubmission();
		let isFormValid = validateForm();
		if (isFormValid) {
			// the field has a value it's a spam bot
			if (!leadForm.querySelector("#honeypot").value) {
				if (sectionSettings.form_submission_flow === 'HTML_FORM_SUBMIT') {
					appendContactInfoToRetUrl();
					return leadForm.submit();
				}
				if (isExternalEndpoint) {
					switch (sectionSettings.form_submission_flow) {
						case "SALES_FORCE":
							await submitToFormIngestion();
							break;
						case "EXTERNAL_ENDPOINT":
							let resp = await submitToExternalSource();
							if (resp.status == true) {
								window.location.replace(sectionSettings.form_callback_url);
							}
							break;
						case "EXTERNAL_ENDPOINT_SALES_FORCE":
							await submitToExternalSource();
							await submitToFormIngestion();
							break;
						case "EXTERNAL_ENDPOINT_SALES_FORCE_WARRANTY":
							await submitToFormIngestion();
							break;
					}
				} else {
					submitToFormIngestion();
				}
			} else {
				setLoading(false);
			}
		} else {
			setLoading(false);
		}
	});

	/**
	 * Appends the contact info to the return URL so that it will show up in the thank you page
	 */
	function appendContactInfoToRetUrl() {
		const contactInputEl = formSection.querySelector('input[name=email]');
		const retUrlInputEl = formSection.querySelector('input[name=retURL]');
		if (!contactInputEl || !retUrlInputEl) return;
		retUrlInputEl.value = `${retUrlInputEl.value}?email=${contactInputEl.value}`
	}

	async function submitToFormIngestion() {
		const formData = new FormData(leadForm);
		let payloadData = {};
		formData.forEach((value, key) => (payloadData[key] = value));
		delete payloadData["captcha_settings"];
		payloadData.cookies = document.cookie.replace(/"/g, '\\"');
		payloadData.referrer_url = document.referrer;
		payloadData.last_url = window.location.href;
		payloadData.ga_id = utilFetchCookieValue("_ga");
		payloadData.affiliate_id = utilFetchCookieValue('affiliate_id');
		payloadData.affiliate_data = { page_url: utilFetchCookieValue('affiliate_data') };
		payloadData.marketing_opt_in = leadForm.querySelector('#marketing_opt_in')?.checked;
		let latestClickID = utilGetLatestClickID();
		if (latestClickID) {
			payloadData.click_id = latestClickID.clickID.value;
			payloadData.platform = latestClickID.platform;
		}
		// Map UTM values from cookies to payload data
		const cookiesKeyFieldMapping = {
			utm_campaign: "utm_campaign",
			utm_medium: "utm_medium",
			utm_source: "utm_source",
			utm_term: "utm_term",
			utm_content: "utm_content",
			gclid: "shopify_gclid__c",
			fbclid: "facebook_fbclid",
			landing_url: "landing_url",
		};

		for (const [key, input] of Object.entries(cookiesKeyFieldMapping)) {
			// console.log("looping in progress", key, input, payloadData[input]);
			// Check if the property exists in payloadData and is either not present or empty
			if (typeof payloadData[input] === "string" && payloadData[input].trim() === "" || payloadData[input] === null) {
				// console.log("mapped for", key, input, utilFetchCookieValue(key));
				payloadData[input] = utilFetchCookieValue(key);
			}
		}
		// console.log(payloadData, "payload data");
		let url = sectionSettings.form_url;
		const formSource = sectionSettings.form_source;
		
		if (formSource) {
			url = `${url}?source=${formSource}`;
		}
		if(sectionSettings.form_submission_flow === "WEB_TO_SALES_INGESTOR"){
			url = `${sectionSettings.web_to_sales_ingestor_url}?source=${formSource}`;
		}
		const requestOptions = {
			method: "POST",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(payloadData),
		};
		try {
			const response = await fetch(url, requestOptions);
			const data = await response.json();
			if(sectionSettings.form_submission_flow !== "EXTERNAL_ENDPOINT_SALES_FORCE_WARRANTY"){
				setLoading(false);
			}
			
			if (typeof grecaptcha !== "undefined" && grecaptcha.enterprise && typeof grecaptcha.enterprise.reset === "function") {
				grecaptcha.enterprise.reset();
			}
			if (data.status === "success") {
				leadForm.reset();
				let leadkeyArr = localStorage.getItem("lead_form_submissions")
					? JSON.parse(localStorage.getItem("lead_form_submissions"))
					: [];
				let caseArr =  localStorage.getItem("case_form_submissions")
				? JSON.parse(localStorage.getItem("case_form_submissions"))
				: [];
				if(sectionSettings.form_submission_flow === "WEB_TO_SALES_INGESTOR"){
					caseArr.push({ [data.id]: payloadData });
					localStorage.setItem("case_form_submissions", JSON.stringify(caseArr));
				} else {
					leadkeyArr.push({ [data.lead_key]: payloadData });
					localStorage.setItem("lead_form_submissions", JSON.stringify(leadkeyArr));
				}

				if(sectionSettings.form_submission_flow === "EXTERNAL_ENDPOINT_SALES_FORCE_WARRANTY"){
					const warrantyResp = await registerWarranty(data.lead_key, payloadData);
					setLoading(false);
					if(warrantyResp.success){
						document.querySelector(".warranty-form__msg_container").style.display = "block";
					}
				}

				if(sectionSettings.form_submission_flow === "WEB_TO_SALES_INGESTOR"){
					utilSetCookie("last_case_key", data.lead_key, 365);
					await handleFormCallbackFlow(data.id, payloadData, "case");
				} else{
					utilSetCookie("last_lead_key", data.lead_key, 365);
					await handleFormCallbackFlow(data.lead_key, payloadData, "lead");
				}
			}
			if (data.status === "error") {
				alert(data.message);
			}
		} catch (error) {
			console.error(error);
			if (typeof grecaptcha !== "undefined" && grecaptcha.enterprise && typeof grecaptcha.enterprise.reset === "function") {
				grecaptcha.enterprise.reset();
			}
			setLoading(false);
		}
	}

	// async function testingSubmission() {
	// 	await handleFormCallbackFlow("60a4d1bb-b93f-4539-b984-ab6cbc417f98", {
	// 		"oid": "00D5e0000012ruD",
	// 		"type": "Home Scenting",
	// 		"first_name": "Testing",
	// 		"last_name": "Testing",
	// 		"email": "testing@testing.com",
	// 		"phone_mobile": "9790598986",
	// 		"city": "miami",
	// 		"state": "FL",
	// 		"postcode": "26555",
	// 		"lead_comments": "This is a testing submission",
	// 		"lead_source": "",
	// 		"lead_category": "Active Lead",
	// 		"lead_status": "Hot Lead",
	// 		"business_unit": "Aroma360",
	// 		"referrer_url": "",
	// 		"language": "en",
	// 		"lob": "Aroma360",
	// 		"closest_a360_store": "",
	// 		"facebook_fbclid": null,
	// 		"facebook_fbp": "",
	// 		"facebook_fbleadid": "",
	// 		"microsoft_msclkid": "",
	// 		"shopify_gclid__c": null,
	// 		"landing_url": "https://aroma360.com/?rfsn=7688615.0217fd&utm_source=refersion&utm_medium=affiliate&utm_campaign=khawarurrasool?subid=Cj0KCQiAyeWrBhDDARIsAGP1mWStdHYlUJKNc5V25XMRiU0Uz4FJHt8fS-9oWkf9wkn1YVwaPGzq9KoaAq5PEALw_wcB&gclid=Cj0KCQiAyeWrBhDDARIsAGP1mWStdHYlUJKNc5V25XMRiU0Uz4FJHt8fS-9oWkf9wkn1YVwaPGzq9KoaAq5PEALw_wcB",
	// 		"platform": "web",
	// 		"form_url": "",
	// 		"form_id": "home-scenting",
	// 		"source": "website",
	// 		"click_id": "",
	// 		"lead_id": "",
	// 		"campaign_id": "",
	// 		"adset_id": "",
	// 		"ad_id": "",
	// 		"utm_campaign": "cs_w",
	// 		"utm_medium": "wi_proxy",
	// 		"utm_source": "aroma360.com",
	// 		"utm_term": null,
	// 		"utm_content": "hi_IN",
	// 		"xnQsjsdp": "REDACTED",
	// 		"xmIwtLD": "REDACTED",
	// 		"actiontype": "TGVhZHM=",
	// 		"gaconnector_pages_visited": "",
	// 		"ctm_dma": "",
	// 		"ctm_gaid": "",
	// 		"ctm_region": "",
	// 		"ctm_host": "",
	// 		"ctm_zip": "",
	// 		"ctm_gid": "",
	// 		"ctm_area_code": "",
	// 		"ctm_tracking_source": "",
	// 		"ctm_country_code": "",
	// 		"referred_by": "",
	// 		"zc_gad": "",
	// 		"region": "",
	// 		"gaconnector_first_click_campaign": "",
	// 		"gaconnector_first_click_channel": "",
	// 		"gaconnector_first_click_content": "",
	// 		"gaconnector_first_click_landing_page": "",
	// 		"gaconnector_first_click_medium": "",
	// 		"gaconnector_first_click_referrer": "",
	// 		"gaconnector_first_click_source": "",
	// 		"gaconnector_first_click_term": "",
	// 		"gaconnector_last_click_campaign": "",
	// 		"gaconnector_last_click_channel": "",
	// 		"gaconnector_last_click_content": "",
	// 		"gaconnector_last_click_landing_page": "",
	// 		"gaconnector_last_click_medium": "",
	// 		"gaconnector_last_click_referrer": "",
	// 		"gaconnector_last_click_source": "",
	// 		"gaconnector_last_click_term": "",
	// 		"gaconnector_operating_system": "",
	// 		"gaconnector_gclid": "",
	// 		"gaconnector_google_analytics_client_id": "",
	// 		"browser": "",
	// 		"gaconnector_city": "",
	// 		"gaconnector_country": "",
	// 		"device": "",
	// 		"gaconnector_latitude_from_ip": "",
	// 		"gaconnector_longitude": "",
	// 		"gaconnector_time_spent_on_website": "",
	// 		"gaconnector_time_zone": "",
	// 		"gaconnector_number_of_website_visits": "",
	// 		"companyName2": "",
	// 		"eo": "REDACTED",
	// 		"te": "true",
	// 		"g-recaptcha-response": "REDACTED",
	// 		"last_url": "https://aroma360.com/pages/home-scenting",
	// 		"ga_id": "GA1.1.747958112.1702464971",
	// 		"affiliate_id": null,
	// 		"affiliate_data": {
	// 			"page_url": null
	// 		}
	// 	});
	// }

	async function submitToExternalSource() {
		let emailMessage = "";
		if (leadForm.querySelector("#Lead_Comments")) {
			emailMessage = leadForm.querySelector("#Lead_Comments").value;
		}

		let payload = {
			name: leadForm.querySelector("#first_name").value + " " + leadForm.querySelector("#last_name").value,
			email: leadForm.querySelector("#email").value,
			phone: leadForm.querySelector("#phone_mobile").value,
			message: emailMessage,
			origin: window.location.href,
			preferred_lang: languageDictionary[Shopify.locale],
			marketing_opt_in: leadForm.querySelector('#marketing_opt_in')?.checked
		};
		if (leadForm.querySelector("#city") && leadForm.querySelector("#state") && leadForm.querySelector("#zip_code")) {
			payload.city = leadForm.querySelector("#city").value;
			payload.state = leadForm.querySelector("#state").value;
			payload.zip_code = leadForm.querySelector("#zip_code").value;
			payload.page_url = window.location.href;
			payload.country_iso_code = await loadCurrentLocation();
		}
		if (leadForm.querySelector("#order_number") && leadForm.querySelector("#order_number").value) {
			payload.orderId = leadForm.querySelector("#order_number").value;
		}

		//https://lm29746w1l.execute-api.us-east-1.amazonaws.com/api/send-email
		let resp = await fetch(sectionSettings.external_end_point_url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(payload),
		});
		return resp.json();
	}

	async function registerWarranty(last_lead_key, lead_data) {
		let payload = {
			name: lead_data.first_name + " " +  lead_data.last_name,
			email: lead_data.email,
			phone: lead_data.phone_mobile,
			registration_id: last_lead_key,
			diffuser_model: lead_data.diffuser_model,
			order_id: lead_data.order_id,
			purchased_from: lead_data.purchased_from,
		}

		let resp = await fetch(sectionSettings.external_end_point_url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(payload),
		});
		return resp.json();
	}

	function validateForm() {
		isExternalEndpoint = false;
		for (i = 0; i < mndFileds.length; i++) {
			var fieldObj = leadForm[mndFileds[i]];
			if (fieldObj) {
				if (
					(fieldObj.type != "email" || fieldObj.type != "tel") &&
					fieldObj.value.replace(/^\s+|\s+$/g, "").length == 0
				) {
					if (fieldObj.type == "file") {
						alert("Please select a file to upload.");
						return false;
					}
					alert(fldLangVal[i] + " cannot be empty.");
					fieldObj.focus();
					return false;
				} else if (fieldObj.nodeName == "SELECT") {
					if (fieldObj.options[fieldObj.selectedIndex].value == "-None-") {
						alert(fldLangVal[i] + " cannot be none.");
						fieldObj.focus();
						return false;
					}
					if (fieldObj.options[fieldObj.selectedIndex].value == sectionSettings.external_end_point_name || sectionSettings.form_submission_flow === "EXTERNAL_ENDPOINT_SALES_FORCE_WARRANTY") {
						isExternalEndpoint = true;
					}
				} else if (fieldObj.type == "checkbox") {
					if (fieldObj.checked == false) {
						alert("Please accept  " + fldLangVal[i]);
						fieldObj.focus();
						return false;
					}
				} else if (typeof grecaptcha !== "undefined" && gRecaptchaWidget != null && grecaptcha.enterprise.getResponse(gRecaptchaWidget) === "") {
					alert("Please check the reCaptcha");
					return false;
				}
				try {
					if (fieldObj.id == "Last Name") {
						name = fieldObj.value;
					}
				} catch (e) { }
			}
		}
		return true;
	}

	function setLoading(status) {
		if (status) {
			submitBtn.classList.add("loading");
			submitBtn.disabled = true;
		} else {
			submitBtn.classList.remove("loading");
			submitBtn.disabled = false;
		}
	}

	async function handleFormCallbackFlow(leadKey, formDataPayload, type) {
		// console.log(formDataPayload);
		let callBackAction = sectionSettings.form_callback_action;
		let callBackURL = sectionSettings.form_callback_url;
		if (window.dynamicFormPaymentUrlOverride) {
			callBackURL = window.dynamicFormPaymentUrlOverride;
		}
		
		// Determine the key name based on type
		const keyName = type === "case" ? "case_key" : "lead_key";
		
		// caching the form fields to use it in the widget after the form is submitted
		if (callBackAction === "render-widget" && sectionSettings.form_callback_widget != "") {
			const calendlyWidget = widgetRenderArea.querySelector(".calendly-inline-widget");
			const calWidget = widgetRenderArea.querySelector("cal-inline .cal-embed");
			if (calendlyWidget) {
				const calendlyParams = {
					[keyName]: leadKey,
					email: formDataPayload.email || "",
				};
				if (keyName === "case_key") {
					calendlyParams.name = `${formDataPayload.name || ""}`;
				} else {
					calendlyParams.first_name = formDataPayload.first_name || "";
					calendlyParams.last_name = formDataPayload.last_name || "";
				}

				calendlyWidget.setAttribute(
					"data-url",
					preFillUrlParams(
						calendlyParams,
						calendlyWidget.getAttribute("data-url")
					)
				);
			}
			if (calWidget) {
				let preFillParams = {
					[keyName]: leadKey,
					email: formDataPayload.email || "",
				}
				if (keyName === "case_key") {
					preFillParams.name = `${formDataPayload.name || ""}`;
				} else {
					preFillParams.first_name = formDataPayload.first_name || "";
					preFillParams.last_name = formDataPayload.last_name || "";
				}
				calWidget.setAttribute(
					"src",
					preFillUrlParams(
						preFillParams,
						calWidget.getAttribute("src")
					)
				);
			}
			leadForm.style.display = "none";
			widgetRenderArea.style.display = "block";
		}
		// if form action is external url redirect we prefilling the url with form data
		if (callBackURL && callBackAction === "url-redirect") {
			if (callBackURL.includes("stripe")) {
				callBackURL = preFillUrlParams({ client_reference_id: leadKey }, callBackURL);
			}
			if (callBackURL.includes("calendly") || callBackURL.includes("/pages/scenting-consultation")) {

				const urlParams = {
					[keyName]: leadKey,
					email: formDataPayload.email,
					phone: formDataPayload.phone_mobile || ""
				};
				
				// If keyName is case_key, use name instead of first_name and last_name
				if (keyName === "case_key") {
					urlParams.name = `${formDataPayload.name}`;
				} else {
					urlParams.name = `${formDataPayload.first_name} ${formDataPayload.last_name}`;
					urlParams.first_name = formDataPayload.first_name;
					urlParams.last_name = formDataPayload.last_name;
				}

				callBackURL = preFillUrlParams(urlParams, callBackURL);
			}
			if (sectionSettings.append_queryparams) {
				var selectedStoreZip = storeLocations.filter(store => store.dropdown_value == formDataPayload.store_location);
				// to prefill queryparms with cals fields and utms
				var prefillDatas = {
					[keyName]: leadKey,
					name: `${formDataPayload.first_name} ${formDataPayload.last_name}`,
					first_name: formDataPayload.first_name,
					last_name: formDataPayload.last_name,
					email: formDataPayload.email,
					phone: formatPhoneNumber(formDataPayload.phone_mobile || ""),
					utm_campaign: formDataPayload.utm_campaign || "",
					utm_content: formDataPayload.utm_content || "",
					utm_medium: formDataPayload.utm_medium || "",
					utm_source: formDataPayload.utm_source || "",
					utm_term: formDataPayload.utm_term || "",
					affiliate_id: formDataPayload.affiliate_id || "",
					zip: selectedStoreZip[0].zip_code,
				};

				if (formDataPayload.phone_mobile) {
					prefillDatas.location = JSON.stringify({
						value: "phone",
						optionValue: formatPhoneNumber(formDataPayload.phone_mobile)
					})
				}

				for (var key in prefillDatas) {
					if (prefillDatas.hasOwnProperty(key) && (prefillDatas[key] === "" || prefillDatas[key] === null)) {
						delete prefillDatas[key];
					}
				}

				let queryParams = preFillParamsWithRelativePath(prefillDatas);
				let url = callBackURL + '?' + queryParams;
				window.location.replace(url);
			}
			else {
				window.location.replace(callBackURL);
			}
		}

		if (callBackAction === "invoke-callback" && window.submissionCallBack) {
			await window.submissionCallBack();
		}

		if (callBackAction === "step-form" || callBackAction === "step-form-pb") {
			await initializeCheckout(formDataPayload.email, window.stripePriceVariantId, leadKey);
		}
	}

	document.addEventListener("DOMContentLoaded", function () {
		if (hasURLParameter("calWidget")) {
			// console.info("load cal widget");
			const widgetRenderArea = formSection.querySelector("#widgetRenderArea");
			let lastSubmittedLeadkey = utilFetchCookieValue("last_lead_key");
			let leadSubmissionArr = localStorage.getItem("lead_form_submissions")
				? JSON.parse(localStorage.getItem("lead_form_submissions"))
				: [];
			let lastSubmittedPayload = leadSubmissionArr.filter((l) => l.hasOwnProperty(lastSubmittedLeadkey));
			// console.log(lastSubmittedPayload, "payload asdasd asdasdasd");
			if (lastSubmittedPayload.length) {
				leadForm.style.display = "none";
				widgetRenderArea.style.display = "block";
				const calConfig = {
					name:
						lastSubmittedPayload[0][lastSubmittedLeadkey].first_name +
						"  " +
						lastSubmittedPayload[0][lastSubmittedLeadkey].last_name, // Prefill Name
					email: lastSubmittedPayload[0][lastSubmittedLeadkey].email, // Prefill Email
					phone: lastSubmittedPayload[0][lastSubmittedLeadkey].phone_mobile,
					lead_key: lastSubmittedLeadkey,
				};
				// console.log("cal prefill config", calConfig);
				Cal("init", {
					origin: "https://cal.aroma360.com/team/aroma360",
				});
				Cal("inline", {
					elementOrSelector: "#widgetRenderArea",
					calLink: "exclusive-offer",
					config: calConfig,
				});

				Cal("on", {
					action: "bookingSuccessful",
					callback: (e) => {
						let newLeadSubmissionArr = leadSubmissionArr.filter((l) => !l.hasOwnProperty(lastSubmittedLeadkey));
						localStorage.setItem("lead_form_submissions", JSON.stringify(newLeadSubmissionArr));
						// utilDeleteCookie("last_lead_key");
						let redirectPage = `${window.location.origin}`;
						if (Shopify.locale != "en") {
							redirectPage += `/${Shopify.locale}`;
						}
						redirectPage += "/pages/thank-you";
						setTimeout(() => {
							window.location = redirectPage;
						}, 2500);
					},
				});
				Cal("on", {
					action: "__iframeReady",
					callback: (e) => {
						if (formSection) {
							window.scrollTo({
								top: formSection.offsetTop,
								behavior: "smooth",
							});
						}
					},
				});
			}
		}
		if (sectionSettings.form_render_mode === "STEP_FORM" || sectionSettings.form_render_mode === "STEP_FORM_INJECT") {
			displayStep(1);
		}
		// handleStripeReturnUrl();
	});

	function preFillUrlParams(paramsMap, targetUrl) {
		let prefillParams = [];
		for (let key in paramsMap) {
			if (paramsMap.hasOwnProperty(key)) {
				prefillParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(paramsMap[key])}`);
			}
		}
		let newURL = new URL(targetUrl);
		newURL.search = prefillParams.join("&");
		return newURL.toString();
	}

	$(document).ready(function () {
		// Get all the <a> tags with href of the dynamic form section
		const sectionLinks = document.querySelectorAll(`body a[href="#${sectionSettings.section_wrapper_id}"]`);
		const popUpForm = formSection.querySelector(".lead_form__popup");
		const popUpTrigger = formSection.querySelector("#formPopUpTrigger");

		sectionLinks.forEach(function (link) {
			// replace the href with void
			link.setAttribute("href", "javascript:void(0);");
			// Attach click event to each matching <a> tag
			link.addEventListener("click", function (event) {
				const section = document.getElementById(`${sectionSettings.section_wrapper_id}`);
				section.scrollIntoView({ behavior: "smooth", block: "start" });
			});
		});

		if (sectionSettings.form_render_mode == "INJECT" || sectionSettings.form_render_mode == "INJECT_AND_POPUP" || sectionSettings.form_render_mode == "STEP_FORM_INJECT") {
			let injectableTarget = document.querySelector(`${sectionSettings.injectable_target}`);
			const injectableSource = sectionSettings.form_render_mode == "STEP_FORM_INJECT" ? document.getElementById(`lead-step-form-${sectionId}`) : document.getElementById(`lead-form-${sectionId}`);

			// Check if injectableTarget exists before proceeding
			if (injectableTarget) {
				injectableTarget.appendChild(injectableSource);
				if (popUpForm) {
					document.body.appendChild(popUpForm);
				}
				dispatchInjectEvent();
			} else {
				// payment options block
				const handleMutation = (mutationsList, observer) => {
					for (const mutation of mutationsList) {
						if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
							let injectableTarget = document.querySelector(`${sectionSettings.injectable_target}`);
							//console.log(injectableTarget,"injectible target");
							if (injectableTarget) {
								observer.disconnect();
								injectableTarget.appendChild(injectableSource);
								//console.log("target injected");
								if (popUpForm) {
									document.body.appendChild(popUpForm);
								}
								dispatchInjectEvent();
							}
						}
					}
				};

				// Create a MutationObserver and start observing body changes
				const observer = new MutationObserver(handleMutation);
				const observerConfig = { childList: true, subtree: true };
				observer.observe(document.body, observerConfig);

				setTimeout(() => {
					observer.disconnect();
				}, 15000);
			}


			function dispatchInjectEvent() {
				const event = new CustomEvent('leadform:injected', {
					detail: null
				});
				document.dispatchEvent(event);
			}

		}

		if (popUpTrigger && sectionSettings.trigger_from_external_source === false) {
			popUpTrigger.addEventListener("click", () => togglePopUp());
		}

		if (sectionSettings.external_trigger_class != "") {
			$(`${sectionSettings.external_trigger_class}`).click(() => togglePopUp());
		}

		document.addEventListener("click", (event) => {
			if (popUpForm === event.target) {
				popUpForm.classList.remove("active");
			}
		});

		function togglePopUp() {
			if (popUpForm.classList.contains("active")) {
				document.body.style.overflowY = "unset";
				popUpForm.classList.remove("active");
			} else {
				popUpForm.classList.add("active");
				document.body.style.overflowY = "hidden";
			}
		}
		const handleRecaptchaAvailability = () => {
			if (typeof grecaptcha !== "undefined" && typeof grecaptcha.enterprise !== "undefined" && typeof grecaptcha.enterprise.render === "function") {
				recaptchaObserver.disconnect();
				gRecaptchaWidget = grecaptcha.enterprise.render(`recaptcha_${sectionId}`, {
					sitekey: "XXXXXXXXXXXXXXXXXXX",
				});
			}
		};

		const recaptchaObserver = new MutationObserver(handleRecaptchaAvailability);
		const observerOptions = {
			childList: true,
			subtree: true,
		};

		recaptchaObserver.observe(document.body, observerOptions);
		handleRecaptchaAvailability();

		// Map UTM values from cookies to input fields
		const cookiesKeyFieldMapping = {
			utm_campaign: "utm_campaign",
			utm_medium: "utm_medium",
			utm_source: "utm_source",
			utm_term: "utm_term",
			utm_content: "utm_content",
			gclid: "shopify_gclid__c",
			fbclid: "facebook_fbclid",
			landing_url: "landing_url",
		};

		for (const [key, input] of Object.entries(cookiesKeyFieldMapping)) {
			if (utilFetchCookieValue(key)) {
				const inputElement = leadForm.querySelector(`input[name="${input}"]`);
				if (inputElement) {
					inputElement.value = utilFetchCookieValue(key) || "";
				}
			}
		}

		// Set user language preference to input field
		const languagePreferenceInput = leadForm.querySelector(`#Preferred_Language`);
		if (languagePreferenceInput) {
			languagePreferenceInput.value = Shopify.locale;
		}
	});

	function appendAbsolutePath(url) {
		let absolutePattern = /^(?:[a-z]+:)?\/\//i;
		let absolutePath = url;

		if (!absolutePattern.test(url)) {
			absolutePath = window.location.origin + url;
		}

		return absolutePath;
	}

	function timestamp() {
		var response = leadForm.querySelector(".g-recaptcha-response");
		let capchaSettings = leadForm.querySelector('input[name="captcha_settings"]');
		if (capchaSettings && (response == null || (response.value && response.value.trim() == ""))) {
			try {
				var elems = JSON.parse(capchaSettings.value);
				elems["ts"] = JSON.stringify(new Date().getTime());
				capchaSettings.value = JSON.stringify(elems);
			} catch (e) {}
		}
	}
	setInterval(timestamp, 500);

	function hasURLParameter(parameter) {
		parameter = parameter.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + parameter + "(=([^&#]*)|&|#|$)");
		return regex.test(window.location.href);
	}

	function preFillParamsWithRelativePath(paramsMap) {
		let prefillParams = [];
		for (let key in paramsMap) {
			if (paramsMap.hasOwnProperty(key)) {
				prefillParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(paramsMap[key])}`);
			}
		}
		let queryParams = prefillParams.join("&");
		return queryParams;
	}

	function formatPhoneNumber(phoneNumber) {
		if (phoneNumber.length === 10) {
			return "1" + phoneNumber;
		}
		return phoneNumber;
	}

	function loadCurrentLocation() {
		return new Promise((resolve) => {
			if (typeof Rebuy !== 'undefined' && Rebuy._status === 'initialized' && typeof Rebuy.getGeolocation === 'function') {
				Rebuy.getGeolocation().then(resp => {
					resolve(resp && resp.country_code ? resp.country_code : null);
				}).catch(() => {
					resolve(null);
				});
			} else {
				resolve(null);
			}
		});
	}

	async function initializeCheckout(email, variantId, leadKey) {
		//console.log("initiating checkout");
		if (!variantId) throw new Error("Price Variant ID not provided to stripe");
		displayStep(2);
		try {
			const fetchClientSecret = async () => {
				const response = await fetch(sectionSettings.stripe_cloud_func_url, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						type: "create_checkout_session",
						business_unit: "ar",
						customer_email: email,
						lead_key: leadKey,
						variant_id: parseInt(variantId)
					})
				});
				const { clientSecret } = await response.json();
				return clientSecret;
			};
			const handleComplete = async function () {
				let event = new CustomEvent('stepform:stripe_complete');
				document.dispatchEvent(event);
				setTimeout(() => {
					displayStep(3);
					checkout.destroy();
				}, 2100);
			}
			// Initialize Checkout
			const checkout = await stripe.initEmbeddedCheckout({
				fetchClientSecret,
				onComplete: handleComplete
			});

			// Mount Checkout
			checkout.mount('#stripeCheckout');
		} catch (error) {
			console.error("STRIPE ERROR:", error);
			checkout.destroy();
		}
	}

	/**
	  * Handles the return url from stripe checkout captures the session token from stripe.
	  */
	function handleStripeReturnUrl() {
		const url = new URL(window.location.href);
		const stripeCheckoutSessionId = url.searchParams.get('stripe_checkout_session_id');
		if (stripeCheckoutSessionId) { verifyStripeCheckoutToken(stripeCheckoutSessionId); }
	}

	async function verifyStripeCheckoutToken(token) {
		try {
			if (!token) throw new Error("Checkout token missing or invalid");
			const resp = await fetch(sectionSettings.stripe_cloud_func_url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					type: "session_status",
					session_id: token
				})
			});
			const respData = await resp.json();
			if (respData?.status === "complete") {
				displayStep(3);
				// mutate the history to clear the strip checkout token from history
				window.addEventListener('beforeunload', eraseStripeTokenFromHistory);
			} else if (respData?.status === "open") {
				alert('Payment failed. Please try again.');
				const lastSubmittedLeadkey = utilFetchCookieValue("last_lead_key")
				let leadFormSubmissions = JSON.parse(localStorage.getItem('lead_form_submissions'));
				let lastLeadFormEntry = leadFormSubmissions.find((l) => l.hasOwnProperty(lastSubmittedLeadkey));
				if (lastLeadFormEntry) {
					displayStep(2);
					await initializeCheckout(lastLeadFormEntry.email, window.stripePriceVariantId, lastSubmittedLeadkey);
				}
			}
			// console.log(respData, "response data");
		} catch (error) {
			console.error(error);
		}
	}
}

/**
 * Clears the stripe token from URL param once the the payment is verified
 */
function eraseStripeTokenFromHistory() {
	const url = new URL(window.location.href);
	const stripeCheckoutSessionId = url.searchParams.get('stripe_checkout_session_id');
	if (stripeCheckoutSessionId) {
		url.searchParams.delete('stripe_checkout_session_id');
		window.history.replaceState(null, '', url.toString());
	}
}


/**
 * Navaigates between step form steps
 * @param {number} stepIndex 
 */

function displayStep(stepIndex) {
	const targetStep = $(`.lead-form__step[data-form-step="${stepIndex}"]`);
	if (targetStep) {
		const totalSteps = 3;
		const stepProgress = ((100 / totalSteps) * stepIndex) - 100;
		$(`.lead-form__step`).removeClass('active');
		$(`.step-form__progress-bar`).css('transform', `translateX(${stepProgress}%)`);
		for (let i = 1; i <= stepIndex; i++) {
			$(`.step-form__progress-point[data-form-step="${i}"]`).addClass('active');
		}
		targetStep.addClass('active');
	}
}